<template>
  <section v-if="!loading">
    <Grid class="fshr-tripCardList" v-if="hotels.length">
      <GridItem
        v-for="hotel in hotels"
        class="fshr-tripCardList__item"
        :sm="sizes.sm"
        :md="sizes.md"
        :xl="sizes.xl"
        :key="hotel.id"
      >
        <TripCard :hotel="hotel" :translations="translations" :serverurl="serverurl" :api_url_addtofavorite="api_url_addtofavorite" :logged="logged" :api_url_watchdog="api_url_watchdog" :api_url_watchdoglogged="api_url_watchdoglogged"/>
      </GridItem>
    </Grid>
    <div class="no-results" v-else>
      {{ getTranslation("NebyliNalezenyZadneVysledky") }}
    </div>
  </section>
  <section v-else>
    <Grid class="fshr-tripCardList fshr-tripCardList--is-loading">
      <GridItem
        v-for="index in 15"
        class="fshr-tripCardList__item"
        :sm="sizes.sm"
        :md="sizes.md"
        :xl="sizes.xl"
        :key="index"
      >
        <TripCardLoading />
      </GridItem>
    </Grid>
  </section>
</template>

<script>
import TripCard from "./TripCard.vue";
import Grid from "./elements/Grid.vue";
import GridItem from "./elements/GridItem.vue";
import TripCardLoading from "./TripCardLoading.vue";

export default {
  name: "trip-card-list",
  components: {
    TripCard,
    Grid,
    GridItem,
    TripCardLoading,
  },
  props: {
    hotels: {
      type: Array,
      required: true,
    },
    logged: {
      type: Boolean,
      required: false,
      default: false,
    },
    api_url_watchdoglogged: {
      default: "",
      type: String,
      required: false
    },
    api_url_watchdog: {
      default: "",
      type: String,
      required: false
    },
    loading: {
      type: Boolean,
      required: true,
      default: true,
    },
    translations: {
      type: Array,
      required: true,
    },
    api_url_addtofavorite: {
      default: "/JSON/addtofavorite.json",
      type: String,
      required: false,
    },
    serverurl: {
      required: false,
      type: String,
      default: "/",
    },
    sizes: {
      type: Object,
      required: false,
      default: () =>{
        return {
          sm: 6,
          md: 4,
          xl: 3,
        }
      }
    }
  },
};
</script>

<style lang="less">
  @import './../less/variables';
  @import './../../../../../Content/css/component-trip-card-list';
</style>